import { render, staticRenderFns } from "./listChildrenInstallations.vue?vue&type=template&id=47b2c4cd&scoped=true&"
import script from "./listChildrenInstallations.vue?vue&type=script&lang=js&"
export * from "./listChildrenInstallations.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "47b2c4cd",
  null
  
)

export default component.exports